import { Record } from 'immutable';

class VehicleCriteriaModel extends Record({
    category: 'CAR',
    colanderSlug: null,
    vehicleStatuses: ['FOR_SALE', 'SOLD', 'VIRTUAL', 'ON_HOLD'],
    onlyBuiltVehicles: true,
    drivetrains: [],
    fuelTypes: [],
    exteriorColorIds: [],
    frameStyleTypes: [],
    makeIds: [],
    modelIds: [],
    odometerRange: {},
    salePriceRange: {},
    textQuery: '',
    transmissionTypes: [],
    yearRange: {},
    catalogMakeIds: [],
    catalogModelIds: [],
}) {
    mapToLimitedMandatoryPropertySetObject() {
        const plain = this.toJS();

        return Object.keys(plain).reduce((acc, value) => {
            if (['category', 'colanderSlug', 'vehicleStatuses', 'onlyBuiltVehicles'].includes(value)) {
                acc[value] = plain[value];
            }
            return acc;
        }, {});
    }
}

export default VehicleCriteriaModel;
